export default {
	bind(el, binding) {
		const color = binding.value;
		const colorClassOrStyleResult = Bandwango.colorClassOrStyle(color);
		if(colorClassOrStyleResult.class) {
			const classes = colorClassOrStyleResult.class.split(' ');
			classes.forEach(cls => el.classList.add(cls));
		}
		else if(colorClassOrStyleResult.style) {
			el.style.color = colorClassOrStyleResult.style.color;
		}
	}
};